import { render } from "./FilledRecently.vue?vue&type=template&id=3a4ec912"
import script from "./FilledRecently.vue?vue&type=script&lang=ts"
export * from "./FilledRecently.vue?vue&type=script&lang=ts"

import "./FilledRecently.vue?vue&type=style&index=0&id=3a4ec912&lang=scss"
script.render = render

export default script